import React from 'react';
import * as d3 from 'd3-shape';

export default class AreaSeries extends React.Component {
  render() {
    const {scales, data, fill, fillOpacity, gradient, className} = this.props;
    const {xScale, yScale} = scales;

    const area = d3
      .area()
      .x(d => xScale(d.date))
      .y0(yScale.range()[0])
      .y1(d => yScale(d.value));

    return (
      <path
        className={className}
        d={area(data)}
        fill={fill ? fill : `url(#${gradient.id})`}
        fillOpacity={fillOpacity}
      />
    );
  }
}
